<script setup>

import {onMounted, ref, watch} from "vue";
import Repository from "../Helpers/Repository";
import {useI18n} from "vue-i18n";
import Language from "../Helpers/Language";

const {t} = useI18n();

const props = defineProps({
    eventDays: Array,
});

const tags = ref([]);
const stages = ref([]);

const emits = defineEmits(['filterSchedules', 'officialStage']);

const activeDay = ref(null);
const activeStage = ref(null);
const activeTag = ref(null);
const rawSearch = ref(null);

onMounted(() => {
    new Repository().getStages('oficial').then((response) => {
        if (response.data.length === 1) {
            new Repository().getStages(null, response.data[0]['id']).then((response) => {
                stages.value = response.data;
            });

            emits('officialStage', response.data[0]['id']);
        }
    });

    new Repository().getTags().then((response) => {
        tags.value = response.data;
    });
});

const filterDay = (day) => {
    if (activeDay.value === day) {
        return;
    }

    activeDay.value = day;
    activeTag.value = null;
    activeStage.value = null;
    rawSearch.value = null;
    emits('filterSchedules', filterSchedules());
}

watch(() => {
    if (activeDay.value === null && props.eventDays.length > 0) {
        activeDay.value = props.eventDays[0];
    }
});

const filterSchedules = () => {
    return {
        day: activeDay.value,
        stage: activeStage.value,
        tag: activeTag.value,
        search: rawSearch.value,
    };
}

const formatDayLabel = (day) => {
    return new Date(`${day} 00:00:00`).toLocaleDateString(Language.getLanguage() ?? null, {
        day: "numeric",
        month: "long",
    });
}

</script>

<template>
    <header>
        <ul>
            <li v-for="day in eventDays">
                <button :class="{'active': activeDay === day}" type="button" @click="filterDay(day)">
                    {{ formatDayLabel(day) }}
                </button>
            </li>
        </ul>
<!--        <form>-->
<!--            <span>{{ t('Filtrar por') }}</span>-->
<!--            <label>-->
<!--                <select name="palco" v-model="activeStage">-->
<!--                    <option :value="null" :selected="activeStage === null">{{ t('Palco') }}</option>-->
<!--                    <option v-for="stage in stages" :value="stage['id']">{{ stage['name'] }}</option>-->
<!--                </select>-->
<!--                <select name="tag" v-model="activeTag">-->
<!--                    <option :value="null" :selected="activeTag === null">{{ t('Tag') }}</option>-->
<!--                    <option v-for="tag in tags" :value="tag['id']">{{ tag['name'] }}</option>-->
<!--                </select>-->
<!--                <input :placeholder="t('Buscar por palavra-chave')" name="search" v-model="rawSearch">-->
<!--            </label>-->
<!--            <button type="button" @click="$emit('filterSchedules', filterSchedules())">{{ t('Buscar') }}</button>-->
<!--        </form>-->
    </header>
</template>

<style scoped>

</style>
